/* Modal del look (snippets/lej-look-modal.liquid). Lo comparten #LejanStyleBook
   (sections/lejan-community-artu.liquid) y See the fit (test A/B de la PDP).

   Figma 11745:13567 (PC) · 11745:13659 (móvil). La sección que lo usa crea una
   instancia y le pasa la lista de looks:

     var m = new LejLookModal(el, { buyEnabled, showPrice, strings });
     m.open(items, index, opener);

   items[i] = { media: '<video>' | '<img>' (outerHTML), title, caption, handle,
                social, btnUrl, btnText, videoStart, videoEnd, products: [...] }

   Con vídeo, la barra de progreso se llena con lo que dura y al acabar pasa al
   siguiente look (excepción al «sin autoplay» de la ficha `carrusel`, solo dentro
   del modal). Se para mientras se elige talla, se añade, hay foco de teclado en la
   info o la pestaña está oculta. El ratón encima de la info NO lo para (Hugo, 07-10). Con reduced-motion no avanza: el vídeo hace
   bucle. Con foto no hay barra y se navega a mano.

   Talla: la última que el usuario elige (en la PDP o en el modal) y, si no ha elegido
   ninguna, la marcada en la PDP (ab2026-01 cerrado: gana la preselección). Si el
   producto del look no la tiene disponible, «Selecciona una talla» y AÑADIR abre las
   tallas. Con una sola fila que añadir, el botón dice la talla: «AÑADIR · TALLA 38». */
(function () {
  if (window.LejLookModal) return;

  var ICON_VOL_ON = 'https://cdn.shopify.com/s/files/1/0720/5630/7997/files/volume_up_24dp_FFFFFF_FILL0_wght200_GRAD0_opsz24.svg?v=1746462980';
  var ICON_VOL_OFF = 'https://cdn.shopify.com/s/files/1/0720/5630/7997/files/volume_off_24dp_FFFFFF_FILL0_wght200_GRAD0_opsz24.svg?v=1746462980';
  var SOCIAL_URLS = {
    facebook: 'https://facebook.com/',
    instagram: 'https://instagram.com/',
    pinterest: 'https://pinterest.com/',
    tiktok: 'https://www.tiktok.com/@',
    youtube: 'https://www.youtube.com/'
  };
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Talla del usuario: la última elegida en la PDP (pills del picker o del sticky) o en
     el modal; si no hay, la marcada en la PDP. */
  var userSize = '';
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input.opt-btn') && t.checked) userSize = String(t.value);
  }, true);
  function currentSize() {
    if (userSize) return userSize;
    var c = document.querySelector('input.opt-btn:checked');
    return c ? String(c.value) : '';
  }

  function attr(s) { return String(s || '').replace(/"/g, '&quot;'); }

  function LejLookModal(modal, o) {
    /* Una instancia por modal: si ya hay una, se reutiliza (los listeners no se duplican). */
    if (modal.lejLookModal) return modal.lejLookModal;
    modal.lejLookModal = this;
    o = o || {};
    /* Colgado de body: dentro de un ancestro sticky/transform (la columna de compra de
       la PDP) su z-index queda atrapado en ese contexto y el header le pasa por encima. */
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    this.modal = modal;
    this.inner = modal.querySelector('.modal-inner');
    this.buyEnabled = !!o.buyEnabled;
    this.showPrice = o.showPrice !== false;
    this.icons = o.icons || {};
    this.s = o.strings || {};
    this.wantWide = modal.dataset.lcaWide === 'true';
    this.uid = modal.id;
    this.q = function (sel) { return modal.querySelector(sel); };
    this.imgWrap = this.q('.modal-image-inner');
    this.text = this.q('.modal-text');
    this.title = this.q('.modal-title');
    this.caption = this.q('.modal-caption');
    this.socialLine = this.q('.social-line');
    this.socialIcon = this.q('.social-icon');
    this.socialHandle = this.q('.social-handle');
    this.btn = this.q('.modal-btn');
    this.prodBox = this.q('.modal-products');
    this.addBtn = this.buyEnabled ? this.q('.add-all-btn') : null;
    this.addMsg = this.buyEnabled ? this.q('.add-all-msg') : null;
    this.addLabel = this.addBtn ? this.addBtn.textContent.trim() : '';
    this.sizeWord = this.addBtn ? String(this.addBtn.dataset.sizeLabel || '').toLocaleUpperCase(document.documentElement.lang || undefined) : '';
    this.sound = this.q('.sound-toggle');
    this.soundIcon = this.sound ? this.sound.querySelector('.sound-icon') : null;
    this.progress = this.q('.lca-progress__fill');
    this.items = [];
    this.current = 0;
    this.isOpen = false;
    this.lock = false;
    this.opener = null;
    this.raf = null;
    this.bind();
  }

  var P = LejLookModal.prototype;

  P.bind = function () {
    var self = this, m = this.modal;
    this.onKey = function (e) {
      if (e.key === 'ArrowLeft') self.go(-1);
      else if (e.key === 'ArrowRight') self.go(1);
      else if (e.key === 'Escape') self.close();
      else if (e.key === 'Tab') self.trapFocus(e);
    };
    this.onVisibility = function () { self.sync(); };
    this.q('.modal-close').addEventListener('click', function () { self.close(); });
    ['.modal-prev', '.modal-prev-mobile'].forEach(function (s) {
      self.q(s).addEventListener('click', function (e) { e.stopPropagation(); self.go(-1); });
    });
    ['.modal-next', '.modal-next-mobile'].forEach(function (s) {
      self.q(s).addEventListener('click', function (e) { e.stopPropagation(); self.go(1); });
    });
    m.addEventListener('click', function (e) { if (!self.lock && e.target === m) self.close(); });
    if (this.sound) this.sound.addEventListener('click', function (e) { e.stopPropagation(); self.toggleSound(); });
    if (this.addBtn) this.addBtn.addEventListener('click', function (e) { e.preventDefault(); self.addAll(); });

    /* Foco de teclado (:focus-visible): un clic deja el foco en el botón y no debe
       dejar el vídeo parado. */
    this.text.addEventListener('focusin', function () { self.sync(); });
    this.text.addEventListener('focusout', function () { setTimeout(function () { self.sync(); }, 0); });

    /* Swipe horizontal sobre el medio en móvil. */
    var x0 = null, y0 = null, media = this.q('.modal-image');
    media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    media.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.go(dx < 0 ? 1 : -1);
    }, { passive: true });

    /* «Modificar» abre las tallas de su fila. Elegir una cambia la variante que añade
       AÑADIR, la talla y el precio, y pliega el panel. */
    this.prodBox.addEventListener('click', function (e) {
      var edit = e.target.closest('button.lca-item__edit');
      if (edit) {
        var box = document.getElementById(edit.getAttribute('aria-controls'));
        if (box) { box.hidden = !box.hidden; edit.setAttribute('aria-expanded', String(!box.hidden)); }
        self.sync();
        return;
      }
      var chip = e.target.closest('.lca-item__chip');
      if (!chip) return;
      var card = chip.closest('.product-card'),
          size = card.querySelector('.lca-item__size'),
          now = card.querySelector('.lca-item__price-now'),
          was = card.querySelector('.lca-item__price-was'),
          btn = card.querySelector('button.lca-item__edit');
      card.dataset.variant = chip.dataset.variantId;
      card.querySelectorAll('.lca-item__chip').forEach(function (c) {
        var on = c === chip;
        c.setAttribute('aria-pressed', String(on));
        if (on) c.setAttribute('data-lj-surface', 'inverse'); else if (!c.disabled) c.removeAttribute('data-lj-surface');
      });
      if (size) size.textContent = chip.textContent;
      if (now && chip.dataset.price) now.textContent = chip.dataset.price;
      if (now && chip.dataset.compare) {
        if (!was) { was = document.createElement('s'); was.className = 'lca-item__price-was'; now.parentNode.appendChild(was); }
        was.textContent = chip.dataset.compare;
      } else if (was) { was.remove(); }
      chip.parentNode.hidden = true;
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
      userSize = String(chip.textContent);
      self.updateAdd();
      self.sync();
    });
  };

  /* Standard y Wide del mismo color comparten post: se queda el de la horma de la
     página (en la home y en las PDP que no son Wide, el Standard). */
  P.dedupeFit = function (list) {
    var want = this.wantWide, pick = {};
    function key(p) { return String(p.title).replace(/\s+wide\b/i, '').toLowerCase(); }
    list.forEach(function (p) {
      var k = key(p), prev = pick[k];
      if (!prev || (!!p.wide === want && !!prev.wide !== want)) pick[k] = p;
    });
    return list.filter(function (p) { return pick[key(p)] === p; });
  };

  /* Filas del look con la línea del carrito (`tarjeta-horizontal`): miniatura, nombre,
     talla, «Modificar» y precio. Las tallas se cambian con chips inline (ficha `chip`:
     las agotadas se ven, apagadas) y AÑADIR lee el data-variant de cada fila. Sin talla
     (accesorios) o con el producto agotado entero, «Info» a la PDP, que es donde vive
     el aviso de reposición; esa fila no entra en AÑADIR. */
  P.productsHTML = function (list) {
    var self = this, s = this.s, size = currentSize();
    return this.dedupeFit(list).map(function (p, pi) {
      var vs = p.variants || [],
          avail = vs.filter(function (v) { return v.available; }),
          soldOut = p.available === false || !avail.length,
          noSize = vs.length === 1 && vs[0].title === 'Default Title',
          cur = noSize ? (avail[0] || vs[0]) : (avail.filter(function (v) { return size && String(v.title) === size; })[0] || null),
          vid = soldOut || noSize || !cur ? '' : cur.id,
          name = String(p.title).split(' - ').join(' '),
          hidden = '<span class="visually-hidden"> ' + name + '</span>',
          sizesId = self.uid + '-sizes-' + pi,
          edit = '', sizes = '', price = '', sizeLabel = '';
      if (soldOut) sizeLabel = s.soldOut;
      else if (!noSize) sizeLabel = cur ? cur.title : (self.buyEnabled ? s.selectSize : '');
      if (soldOut || noSize) {
        edit = '<a class="lca-item__edit" href="' + p.url + '" target="_blank" rel="noopener">' + s.info + hidden + '</a>';
      } else if (self.buyEnabled && vs.length > 1) {
        edit = '<button type="button" class="lca-item__edit" aria-expanded="false" aria-controls="' + sizesId + '">' + s.edit + hidden + '</button>';
        sizes = '<div class="lca-item__sizes" id="' + sizesId + '" role="group" aria-label="' + attr(name) + '" hidden>' + vs.map(function (v) {
          var on = String(v.id) === String(vid);
          return '<button type="button" class="lca-item__chip" data-variant-id="' + v.id + '" data-price="' + attr(v.price) + '" data-compare="' + attr(v.compare) + '" aria-pressed="' + on + '"' + (on ? ' data-lj-surface="inverse"' : '') + (v.available ? '' : ' disabled data-lj-surface="muted"') + '>' + v.title + '</button>';
        }).join('') + '</div>';
      }
      if (self.showPrice) {
        price = '<div class="prod-price"><span class="lca-item__price-now">' + ((cur && cur.price) || p.price) + '</span>' + (cur && cur.compare ? '<s class="lca-item__price-was">' + cur.compare + '</s>' : '') + '</div>';
      }
      return '<div class="product-card" data-variant="' + vid + '"' + (soldOut ? ' data-sold-out' : '') + (noSize ? ' data-no-size' : '') + '>'
        + '<div class="lca-item__main">'
        + '<a class="lca-item__thumb" href="' + p.url + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true" data-lj-surface="muted"><img src="' + p.image + '" alt="" width="86" height="96"></a>'
        + '<div class="lca-item__info"><div class="lca-item__details">'
        + '<a class="prod-title" href="' + p.url + '" target="_blank" rel="noopener">' + name + '</a>'
        + (sizeLabel ? '<span class="lca-item__size">' + sizeLabel + '</span>' : '')
        + edit + '</div>' + price
        + '</div></div>' + sizes + '</div>';
    }).join('');
  };

  /* Con una sola fila que añadir y su talla elegida, el botón la dice. */
  P.updateAdd = function () {
    if (!this.addBtn) return;
    var rows = this.prodBox.querySelectorAll('.product-card:not([data-sold-out]):not([data-no-size])');
    var el = rows.length === 1 && rows[0].dataset.variant ? rows[0].querySelector('.lca-item__size') : null;
    this.addBtn.textContent = el && this.sizeWord ? this.addLabel + ' · ' + this.sizeWord + ' ' + el.textContent : this.addLabel;
  };

  P.trapFocus = function (e) {
    var f = [].slice.call(this.modal.querySelectorAll('a[href],button:not([disabled])')).filter(function (el) { return el.getClientRects().length > 0; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1], act = document.activeElement;
    if (!this.modal.contains(act)) { e.preventDefault(); a.focus(); }
    else if (e.shiftKey && act === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && act === z) { e.preventDefault(); a.focus(); }
  };

  P.video = function () { return this.imgWrap.querySelector('video'); };

  P.autoAdvance = function () {
    return this.items.length > 1 && !(reducedMotion && reducedMotion.matches);
  };

  /* ¿Hay algo que pide parar el vídeo y la barra? */
  P.held = function () {
    if (!this.isOpen || document.hidden) return true;
    if (this.text.querySelector(':focus-visible')) return true;
    if (this.addBtn && this.addBtn.getAttribute('aria-busy') === 'true') return true;
    return !!this.prodBox.querySelector('.lca-item__sizes:not([hidden])');
  };

  P.sync = function () {
    var v = this.video();
    if (!v) return;
    if (this.held()) { if (!v.paused) v.pause(); }
    else if (v.paused) { v.play().catch(function () {}); }
  };

  /* Recorte del post (data-video-start/end). Con avance automático, el final del
     tramo pasa al siguiente look; sin él, vuelve al principio del tramo. */
  P.prepareVideo = function (v, item) {
    var self = this,
        start = parseFloat(item.videoStart) || 0,
        end = parseFloat(item.videoEnd) || 0,
        advance = this.autoAdvance();
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.removeAttribute('autoplay');
    v.preload = 'auto';
    if (advance) v.removeAttribute('loop'); else v.setAttribute('loop', '');
    function seekStart() { if (v.currentTime < start) v.currentTime = start; }
    if (start > 0) { v.addEventListener('loadedmetadata', seekStart); if (v.readyState >= 1) seekStart(); }
    var gone = false;
    function done() {
      if (advance) { if (!gone && self.video() === v) { gone = true; self.go(1); } }
      else { v.currentTime = start; v.play().catch(function () {}); }
    }
    v.addEventListener('timeupdate', function () { if (end > 0 && v.currentTime >= end) done(); });
    v.addEventListener('ended', done);
    this.trimStart = start;
    this.trimEnd = end;
  };

  /* Barra: transform scaleX con lo que lleva el tramo (solo se anima transform). */
  P.tick = function () {
    var self = this;
    cancelAnimationFrame(this.raf);
    if (!this.progress) return;
    var v = this.video();
    if (!v || !this.isOpen) { this.progress.style.transform = 'scaleX(0)'; return; }
    (function loop() {
      var d = self.trimEnd > 0 ? self.trimEnd : v.duration,
          r = d > self.trimStart ? (v.currentTime - self.trimStart) / (d - self.trimStart) : 0;
      self.progress.style.transform = 'scaleX(' + Math.max(0, Math.min(1, r || 0)) + ')';
      if (self.isOpen && self.video() === v) self.raf = requestAnimationFrame(loop);
    })();
  };

  P.render = function (i) {
    var self = this, item = this.items[i];
    this.current = i;
    this.lock = true;
    setTimeout(function () { self.lock = false; }, 150);
    this.imgWrap.innerHTML = item.media || '';
    var v = this.video();
    this.inner.dataset.media = v ? 'video' : 'image';
    if (v) {
      this.prepareVideo(v, item);
    }
    if (this.sound) {
      this.sound.style.display = v ? 'flex' : 'none';
      this.soundIcon.src = ICON_VOL_OFF;
      this.sound.setAttribute('aria-pressed', 'false');
    }
    var handle = String(item.handle || '').replace(/^@+/, '');
    if (handle) {
      var social = item.social || 'instagram';
      this.socialIcon.innerHTML = this.icons[social] || '';
      this.socialHandle.textContent = '@' + handle;
      this.socialHandle.href = (SOCIAL_URLS[social] || '') + handle;
      this.socialLine.hidden = false;
    } else {
      this.socialLine.hidden = true;
    }
    this.title.textContent = item.title || '';
    this.caption.textContent = item.caption || '';
    if (item.btnUrl) { this.btn.href = item.btnUrl; this.btn.textContent = item.btnText || ''; this.btn.style.display = 'inline-block'; }
    else { this.btn.style.display = 'none'; }
    this.prodBox.innerHTML = this.productsHTML(item.products || []);
    /* Sin ninguna fila con talla que añadir (todo agotado o solo «Info»), sin AÑADIR. */
    if (this.addBtn) this.addBtn.hidden = !this.prodBox.querySelector('.product-card:not([data-sold-out]):not([data-no-size])');
    this.updateAdd();
    this.hideMsg();
    this.sync();
    this.tick();
  };

  P.open = function (items, i, opener) {
    this.items = items || [];
    if (!this.items.length) return;
    var first = !this.isOpen;
    this.isOpen = true;
    if (first) {
      this.opener = opener || document.activeElement;
      this.modal.removeAttribute('aria-hidden');
      document.body.classList.add('shop-ig-modal-open');
      this.modal.classList.add('animate-open');
      var m = this.modal;
      setTimeout(function () { m.classList.remove('animate-open'); }, 300);
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('visibilitychange', this.onVisibility);
    }
    this.render(i);
    if (first) this.q('.modal-close').focus({ preventScroll: true });
    this.modal.dispatchEvent(new CustomEvent('lej:look-modal:open', { bubbles: true, detail: { index: i, item: this.items[i] } }));
  };

  P.go = function (step) {
    if (!this.isOpen || !this.items.length) return;
    var n = this.items.length, i = (this.current + step + n) % n;
    this.render(i);
    var self = this;
    [this.imgWrap, this.text].forEach(function (el) {
      el.classList.add('slide-anim');
      setTimeout(function () { el.classList.remove('slide-anim'); }, 300);
    });
    if (!this.modal.contains(document.activeElement)) self.q('.modal-close').focus({ preventScroll: true });
  };

  P.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    cancelAnimationFrame(this.raf);
    var v = this.video();
    if (v) v.pause();
    this.imgWrap.innerHTML = '';
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('shop-ig-modal-open');
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.hideMsg();
    if (this.opener && this.opener !== document.body && typeof this.opener.focus === 'function') this.opener.focus({ preventScroll: true });
    this.opener = null;
    this.modal.dispatchEvent(new CustomEvent('lej:look-modal:close', { bubbles: true }));
  };

  P.toggleSound = function () {
    var v = this.video();
    if (!v || !this.sound) return;
    if (v.muted) { v.muted = false; v.removeAttribute('muted'); v.volume = 1; v.play().catch(function () {}); this.soundIcon.src = ICON_VOL_ON; }
    else { v.muted = true; v.setAttribute('muted', ''); this.soundIcon.src = ICON_VOL_OFF; }
    this.sound.setAttribute('aria-pressed', String(!v.muted));
  };

  P.msgText = function (failed) {
    var noStock = (window.theme && theme.strings && theme.strings.noStock) || '';
    return failed.map(function (f) {
      /* El 422 de Shopify ya trae `description` traducida al locale de la petición. */
      return f.msg || (f.title ? f.title + ' — ' + noStock : noStock);
    }).filter(Boolean).join(' · ');
  };
  P.showMsg = function (failed) { if (this.addMsg) { var t = this.msgText(failed); if (t) this.addMsg.textContent = t; } };
  P.hideMsg = function () { if (this.addMsg) this.addMsg.textContent = ''; };

  /* Estado cargando de `boton`: aria-busy lo anuncia y aria-disabled evita el doble
     envío sin quitarle el foco al botón. */
  P.setBusy = function (on) {
    if (!this.addBtn) return;
    this.addBtn.setAttribute('aria-busy', String(on));
    if (on) this.addBtn.setAttribute('aria-disabled', 'true'); else this.addBtn.removeAttribute('aria-disabled');
    this.sync();
  };

  /* Contrato del theme: `on:cart:change` repinta cajón y contador y
     `dispatch:cart-drawer:open` lo abre. Nunca se navega a /cart. */
  P.openCartDrawer = function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { window.location = (window.theme && theme.routes && theme.routes.cart) || '/cart'; return; }
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
    if (drawer.hasAttribute('open')) return;
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: null } }));
  };

  /* Un producto por llamada: /cart/add.js es atómico y una talla agotada tumbaría el
     look entero. Si alguna fila con tallas no tiene talla elegida, se abren sus
     tallas en vez de añadir. */
  P.addAll = function () {
    var self = this, addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    if (this.addBtn && this.addBtn.getAttribute('aria-busy') === 'true') return;
    var pending = this.prodBox.querySelector('.product-card:not([data-sold-out]):not([data-no-size])[data-variant=""]');
    if (pending) {
      var edit = pending.querySelector('button.lca-item__edit'),
          box = edit && document.getElementById(edit.getAttribute('aria-controls'));
      if (box) {
        box.hidden = false;
        edit.setAttribute('aria-expanded', 'true');
        var chip = box.querySelector('.lca-item__chip:not([disabled])');
        if (chip) chip.focus();
      }
      this.sync();
      return;
    }
    var entries = [];
    this.prodBox.querySelectorAll('.product-card:not([data-sold-out])').forEach(function (c) {
      var t = c.querySelector('.prod-title');
      if (c.dataset.variant) entries.push({ id: +c.dataset.variant, title: t ? t.textContent.trim() : '' });
    });
    if (!entries.length) return;
    var added = 0, failed = [];
    this.hideMsg();
    this.setBusy(true);
    entries.reduce(function (chain, entry) {
      return chain.then(function () {
        return fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: entry.id, quantity: 1 }] })
        }).then(function (r) {
          /* fetch no lanza en 4xx: el 422 de la talla que se agota hay que mirarlo a mano. */
          if (!r.ok) {
            return r.json().catch(function () { return {}; }).then(function (err) {
              failed.push({ title: entry.title, msg: (err && (err.description || err.message)) || '' });
            });
          }
          added++;
        }).catch(function () { failed.push({ title: entry.title, msg: '' }); });
      });
    }, Promise.resolve()).then(function () {
      self.setBusy(false);
      if (added) self.modal.dispatchEvent(new CustomEvent('lej:look-modal:add', { bubbles: true, detail: { index: self.current, item: self.items[self.current], added: added } }));
      if (!added) { self.showMsg(failed); return; }
      if (!failed.length) { self.close(); self.openCartDrawer(); return; }
      self.showMsg(failed);
      setTimeout(function () { self.close(); self.openCartDrawer(); }, 2000);
    });
  };

  window.LejLookModal = LejLookModal;
  document.dispatchEvent(new CustomEvent('lej:look-modal:ready'));
})();
